/**
 * L10 — 2D risk / opportunity quadrant assignment.
 */
import { PORTFOLIO_CONFIG } from './portfolioConfig';

export type PortfolioQuadrant = 'go' | 'strategic-bet' | 'safe-small' | 'no-go';

export function riskScoreFromComposite(composite: number): number {
  const c = Math.min(PORTFOLIO_CONFIG.SCORE_MAX, Math.max(PORTFOLIO_CONFIG.SCORE_MIN, composite));
  return PORTFOLIO_CONFIG.SCORE_MAX - c;
}

export function assignQuadrant(riskScore: number, opportunityScore: number): PortfolioQuadrant {
  const lowRisk = riskScore <= PORTFOLIO_CONFIG.QUADRANT_RISK_THRESHOLD;
  const highOpp = opportunityScore >= PORTFOLIO_CONFIG.QUADRANT_OPPORTUNITY_THRESHOLD;
  if (lowRisk && highOpp) return 'go';
  if (!lowRisk && highOpp) return 'strategic-bet';
  if (lowRisk && !highOpp) return 'safe-small';
  return 'no-go';
}

export const QUADRANT_LABELS: Record<PortfolioQuadrant, string> = {
  go: 'GO',
  'strategic-bet': 'STRATEGIC BET',
  'safe-small': 'SAFE BUT SMALL',
  'no-go': 'NO-GO',
};

export const QUADRANT_DESCRIPTIONS: Record<PortfolioQuadrant, string> = {
  go: 'Low blockers and high upside — proceed to full diligence.',
  'strategic-bet': 'High upside with material blockers — senior approval; do not auto-decline.',
  'safe-small': 'Low blockers but limited scale — suitable for incremental deployment.',
  'no-go': 'High blockers and low upside — decline unless strategy changes.',
};

export function summarizeQuadrants(quadrants: PortfolioQuadrant[]): Record<PortfolioQuadrant, number> {
  const counts: Record<PortfolioQuadrant, number> = {
    go: 0, 'strategic-bet': 0, 'safe-small': 0, 'no-go': 0,
  };
  for (const q of quadrants) counts[q] += 1;
  return counts;
}
